/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import React from 'react';
import { Page, Text, Document, View, Image } from '@react-pdf/renderer';
import { get } from 'lodash';
import styles from './styled';
import logo from '../../assets/img/frota_maxima.png';
import NumberFormat from '../../utils/NumberFormat';
import FNumberFormatKm from '../../utils/FNumberFormatKm';

function RelatorioPDF({ data }) {
  if (!data) {
    return (
      <Document>
        <Page style={styles.page}>
          <Text style={styles.header}>Registro de Viagem</Text>
          <Text>Sem dados disponíveis.</Text>
        </Page>
      </Document>
    );
  }

  const totalReceitas = data.Receita.reduce(
    (acc, receita) => acc + receita.valor,
    0
  );
  const totalDespesas =
    data.Despesas.reduce((acc, despesa) => acc + despesa.valor, 0) +
    data.totalcomissao;
  const kmRodado = data.kmretorno - data.kmsaida;
  const consumoDiesel = data.consumo;
  const pesoTransportado = data.peso;
  const pmDiesel =
    data.Despesas.filter((d) => d.TipoDespesa.flag_combustivel).reduce(
      (acc, despesa) => acc + despesa.valor,
      0
    ) / consumoDiesel;
  const mediaKmL = kmRodado / consumoDiesel;
  const fatorKmLT = kmRodado / consumoDiesel / pesoTransportado;
  const comissaoPorKm = data.totalcomissao / kmRodado;
  const margemBruta = totalReceitas - totalDespesas;
  const lucroBrutoPercentual = (margemBruta / totalReceitas) * 100;

  return (
    <Document>
      <Page style={styles.page} size="A4" wrap>
        {/* Cabeçalho */}
        <View style={styles.headerContainer}>
          <Image style={styles.logo} src={logo} alt="Frota Máxima" />
          <Text style={styles.title}>Registro de Viagem</Text>
          <Text style={styles.id}>Viagem #{data.id}</Text>
        </View>

        {/* Empresa, Cliente e Funcionário */}
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginBottom: 10,
            borderWidth: 1,
            borderColor: '#000',
            borderRadius: 5,
            padding: 10,
          }}
        >
          <Text style={{ flex: 1, textAlign: 'left' }}>
            Empresa: {get(data, 'Empresa.nome', '')}
          </Text>
          <Text style={{ flex: 1, textAlign: 'right' }}>
            Funcionário: {get(data, 'Funcionario.nome', '')}
          </Text>
        </View>

        {/* Resumo em 3 cards */}
        <Text style={styles.sectionTitle}>Resumo</Text>
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: 10,
          }}
        >
          <View
            style={{
              flex: 1,
              borderWidth: 1,
              borderColor: '#000',
              borderRadius: 10,
              marginRight: 5,
              padding: 10,
              backgroundColor: '#F0FFF0',
            }}
          >
            <Text
              style={{
                fontWeight: 'bold',
                textAlign: 'center',
                marginBottom: 5,
              }}
            >
              Total Receitas
            </Text>
            <Text style={{ textAlign: 'center' }}>
              R$ {NumberFormat(totalReceitas)}
            </Text>
          </View>
          <View
            style={{
              flex: 1,
              borderWidth: 1,
              borderColor: '#000',
              borderRadius: 10,
              marginHorizontal: 5,
              padding: 10,
              backgroundColor: '#FFFACD',
            }}
          >
            <Text
              style={{
                fontWeight: 'bold',
                textAlign: 'center',
                marginBottom: 5,
              }}
            >
              Total Despesas
            </Text>
            <Text style={{ textAlign: 'center' }}>
              R$ {NumberFormat(totalDespesas)}
            </Text>
          </View>
          <View
            style={{
              flex: 1,
              borderWidth: 1,
              borderColor: '#000',
              borderRadius: 10,
              marginLeft: 5,
              padding: 10,
              backgroundColor: '#E6E6FA',
            }}
          >
            <Text
              style={{
                fontWeight: 'bold',
                textAlign: 'center',
                marginBottom: 5,
              }}
            >
              Lucro Líquido
            </Text>
            <Text style={{ textAlign: 'center' }}>
              R$ {NumberFormat(totalReceitas - totalDespesas)}
            </Text>
          </View>
        </View>

        {/* Informações Gerais em 3 cards */}
        <Text style={styles.sectionTitle}>Informações Gerais</Text>
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginBottom: 10,
          }}
        >
          {/* Card 1: Viagem */}
          <View
            style={{
              flex: 1,
              borderWidth: 1,
              borderColor: '#000',
              borderRadius: 10,
              marginRight: 5,
              padding: 10,
              backgroundColor: '#F0F8FF',
            }}
          >
            <Text
              style={{
                fontWeight: 'bold',
                textAlign: 'center',
                marginBottom: 5,
                backgroundColor: '#D3D3D3',
                padding: 5,
                borderRadius: 5,
              }}
            >
              Viagem
            </Text>
            {[
              {
                label: 'Motorista',
                value: get(data, 'Motoristum.nome', '').split(' ')[0],
              },
              { label: 'Placa', value: get(data, 'Veiculo.placa', '') },
              {
                label: 'Data Saída',
                value: new Date(data.saida).toLocaleDateString('pt-BR'),
              },
              {
                label: 'Data Retorno',
                value: new Date(data.retorno).toLocaleDateString('pt-BR'),
              },
              { label: 'Km Saída', value: FNumberFormatKm(data.kmsaida) },
              { label: 'Km Retorno', value: FNumberFormatKm(data.kmretorno) },
            ].map((item, index) => (
              <View
                key={index}
                style={{
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                  wordBreak: 'break-word',
                }}
              >
                <Text style={{ textAlign: 'left', flex: 1 }}>
                  {item.label}:
                </Text>
                <Text style={{ textAlign: 'right', flex: 1 }}>
                  {item.value}
                </Text>
              </View>
            ))}
          </View>

          {/* Card 2: Consumo */}
          <View
            style={{
              flex: 1,
              borderWidth: 1,
              borderColor: '#000',
              borderRadius: 10,
              marginHorizontal: 5,
              padding: 10,
              backgroundColor: '#FFFACD',
            }}
          >
            <Text
              style={{
                fontWeight: 'bold',
                textAlign: 'center',
                marginBottom: 5,
                backgroundColor: '#FFD700',
                padding: 5,
                borderRadius: 5,
              }}
            >
              Consumo
            </Text>
            {[
              { label: 'Km Rodado', value: FNumberFormatKm(kmRodado) },
              { label: 'P.M. Diesel/L', value: NumberFormat(pmDiesel) },
              { label: 'Cons. Diesel (L)', value: NumberFormat(consumoDiesel) },
              { label: 'Peso (T)', value: NumberFormat(pesoTransportado) },
              { label: 'Média Km/L', value: NumberFormat(mediaKmL) },
              { label: 'Fator KmL/T', value: NumberFormat(fatorKmLT) },
            ].map((item, index) => (
              <View
                key={index}
                style={{
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                }}
              >
                <Text style={{ textAlign: 'left' }}>{item.label}:</Text>
                <Text style={{ textAlign: 'right' }}>{item.value}</Text>
              </View>
            ))}
          </View>

          {/* Card 3: Custo/Faturamento */}
          <View
            style={{
              flex: 1,
              borderWidth: 1,
              borderColor: '#000',
              borderRadius: 10,
              marginLeft: 5,
              padding: 10,
              backgroundColor: '#E6E6FA',
            }}
          >
            <Text
              style={{
                fontWeight: 'bold',
                textAlign: 'center',
                marginBottom: 5,
                backgroundColor: '#9370DB',
                padding: 5,
                borderRadius: 5,
              }}
            >
              Custo/Faturamento
            </Text>
            {[
              { label: 'M. Bruta (R$)', value: NumberFormat(margemBruta) },
              {
                label: 'Lucro Bruto (%)',
                value: `${NumberFormat(lucroBrutoPercentual)}`,
              },
              { label: 'Comissão/Km', value: NumberFormat(comissaoPorKm) },
            ].map((item, index) => (
              <View
                key={index}
                style={{
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                }}
              >
                <Text style={{ textAlign: 'left' }}>{item.label}:</Text>
                <Text style={{ textAlign: 'right' }}>{item.value}</Text>
              </View>
            ))}
          </View>
        </View>

        {/* Lista de Receitas */}
        <Text style={styles.sectionTitle}>Receitas</Text>
        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <Text style={styles.tableCellLeft}>Data</Text>
            <Text style={styles.tableCellLeft}>Ordem de Coleta</Text>
            <Text style={styles.tableCellLeft}>Local de Saída</Text>
            <Text style={styles.tableCellLeft}>Local de Destino</Text>
            <Text style={styles.tableCellLeft}>Cliente</Text>
            <Text style={styles.tableCellRight}>Valor (R$)</Text>
          </View>
          {data.Receita.map((receita, index) => (
            <View style={styles.tableRow} key={index}>
              <Text style={styles.tableCellLeft}>
                {new Date(receita.lancamento).toLocaleDateString('pt-BR')}
              </Text>
              <Text style={styles.tableCellLeft}>{receita.nrcoleta}</Text>
              <Text style={styles.tableCellLeft}>
                {receita.LocalSaida.municipio}
              </Text>
              <Text style={styles.tableCellLeft}>
                {receita.LocalDestino.municipio}
              </Text>
              <Text style={styles.tableCellLeft}>
                {get(receita, 'Cliente.nome', '')}
              </Text>
              <Text style={styles.tableCellRight}>
                {NumberFormat(receita.valor)}
              </Text>
            </View>
          ))}
          <View style={styles.tableFooter}>
            <Text style={styles.tableFooterText}>Total</Text>
            <Text style={styles.tableFooterValue}>
              R$ {NumberFormat(totalReceitas)}
            </Text>
          </View>
        </View>

        {/* Lista de Despesas */}
        <Text style={styles.sectionTitle}>Despesas</Text>
        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <Text style={styles.tableCellLeft}>Data</Text>
            <Text style={styles.tableCellLeft}>Tipo da Despesa</Text>
            <Text style={styles.tableCellLeft}>Descrição</Text>
            <Text style={styles.tableCellLeft}>Nome do Posto</Text>
            <Text style={styles.tableCellRight}>Valor (R$)</Text>
          </View>
          {data.Despesas.map((despesa, index) => (
            <View style={styles.tableRow} key={index}>
              <Text style={styles.tableCellLeft}>
                {new Date(despesa.created_at).toLocaleDateString('pt-BR')}
              </Text>
              <Text style={styles.tableCellLeft}>
                {get(despesa, 'TipoDespesa.nome', '')}
              </Text>
              <Text style={styles.tableCellLeft}>
                {despesa.descricao || '-'}
              </Text>
              <Text style={styles.tableCellLeft}>
                {get(despesa, 'Posto.nome', '-')}
              </Text>
              <Text style={styles.tableCellRight}>
                {NumberFormat(despesa.valor)}
              </Text>
            </View>
          ))}
          <View style={styles.tableFooter}>
            <Text style={styles.tableFooterText}>Total</Text>
            <Text style={styles.tableFooterValue}>
              R$ {NumberFormat(totalDespesas - data.totalcomissao)}
            </Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={styles.tableCellLeft}>Comissão Motorista</Text>
            <Text style={styles.tableCellLeft}>-</Text>
            <Text style={styles.tableCellLeft}>-</Text>
            <Text style={styles.tableCellRight}>
              {NumberFormat(data.totalcomissao)}
            </Text>
          </View>
          <View style={styles.tableFooter}>
            <Text style={styles.tableFooterText}>Total Geral</Text>
            <Text style={styles.tableFooterValue}>
              R$ {NumberFormat(totalDespesas)}
            </Text>
          </View>
        </View>

        {/* Rodapé */}
        <View
          style={{
            position: 'absolute',
            bottom: 10,
            left: 10,
            right: 10,
            flexDirection: 'row',
            justifyContent: 'space-between',
            borderTopWidth: 1,
            borderColor: '#000',
            paddingTop: 5,
          }}
        >
          <Text>Empresa: {get(data, 'Empresa.nome', '')}</Text>
        </View>
      </Page>
    </Document>
  );
}

export default RelatorioPDF;
